export default "__VITE_ASSET__B8Zy$VOL__"